import moment from "moment";

import { Person } from "@/Common/Models/Person/Person";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent, ServerEventWithRequest } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { IMyle_AttachedCommunication_Recall } from "@/Communications/Helpers/AttachedCommunicationHelper";
import { CommunicationsHelper } from "@/Communications/Helpers/CommunicationsHelper";
import { TempLightVacation } from "@/Communications/Models/TempLightVacation";
import { GlobalSendCommunicationStore } from "@/Communications/Stores/GlobalSendCommunicationStore";

class GlobalSendCommunicationResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.Myle_SaveSendMessage, this.saveSendMessage);
        this.RegisterOperation(ServerOperations.Server.Myle_Communications_VerifyEmployeesOnVacation, this.verifyEmployeesOnVacation);

        this.RegisterOperation(ServerOperations.Server.Myle_UpsertRecall, this.saveFromPopup, SubServerOperations.Recalls.SaveFromPopup);
    }

    private saveSendMessage(response: ServerEvent, store: GlobalSendCommunicationStore): void {
        store.SendTaskOrMessageModel = Immutable.fromJS(CommunicationsHelper.GetDefaultTaskMessagePopupModel());
    }

    private verifyEmployeesOnVacation(response: ServerEvent, store: GlobalSendCommunicationStore): void {
        let responseList: TempLightVacation[] = response.Data.IdsAndVacationList;
        let cliniciansWithVacation = responseList.filter(g => {
            let isInVacation = g.IsInVacation;
            if (g.IsInVacation) {
                if (g.FromVacationDate != null)
                    isInVacation = isInVacation && moment() >= moment(g.FromVacationDate);
                if (g.ToVacationDate != null)
                    isInVacation = isInVacation && moment() <= moment(g.ToVacationDate);
            }
            return isInVacation;
        }).map(withVacation => withVacation.ContactFacet_id);

        cacheStore.updateEmployeeCacheForVacation(responseList);

        let allEmployes: Person[] = cacheStore.GetCliniciansAsPersons();
        let employeesWithVacationAsPersons = allEmployes.filter(emp => cliniciansWithVacation.indexOf(emp.ContactFacetId) > -1);

        if (employeesWithVacationAsPersons.length >= 1) {
            store.SendTaskOrMessageModel = store.SendTaskOrMessageModel.set("IsInVacationPopup", true);
            store.SendTaskOrMessageModel = store.SendTaskOrMessageModel.set("EmployeesInVacation", Immutable.List(employeesWithVacationAsPersons));
        }
        else {
            store.MessageTaskActions.SubmitTask(store.SendTaskOrMessageModel);
        }
    }

    private saveFromPopup(response: ServerEventWithRequest<IMyle_AttachedCommunication_Recall>): void {
        if (response.Data.IsSentFromEncounter) {
            sessionStore.dispatch(
                LocalPatientOperations.MedicalNote.LoadAttachedCommunications,
                {
                    encounterId: response.Data.EncounterId
                }
            );
        }
    }
}

export { GlobalSendCommunicationResponseHandler };
